import React, { useState } from "react";

interface MobileBookingLayoutProps {
  classMeta: any;
  pricing: any;
  suiteImages: any[];
  isRoomMode: boolean;

  progressBlock: React.ReactNode;
  pageOne: React.ReactNode;
  guestDetailsBlock: React.ReactNode;
  classSelectorBlock: React.ReactNode;
  calendarBlock: React.ReactNode;
  pricingSummaryBlock: React.ReactNode;
  couponBlock: React.ReactNode;
  stepContent: React.ReactNode;


}

export default function MobileBookingLayout({
  classMeta,
  pricing,
  suiteImages,
  isRoomMode,
  progressBlock,
  pageOne,
  guestDetailsBlock,
  classSelectorBlock,
  calendarBlock,
  pricingSummaryBlock,
  couponBlock,
  stepContent,
  
}: MobileBookingLayoutProps) {
  return (
    /* OUTER WRAPPER — fills real device, centers fixed-size frame */
    <div className="md:hidden w-full h-[100dvh] flex items-center justify-center bg-gray-100 overflow-hidden">
      {/* FIXED DEVICE FRAME */}
      <div
        className="md:hidden flex flex-col bg-white shadow-xl rounded-xl overflow-hidden"
        style={{
          width: "360px", // iPhone 12/13/14/15 width
          maxHeight: "716px", // iPhone 12/13/14/15 height
        }}
      >
        {/* MAIN FLOW */}
        <div className="flex-shrink-0 px-3 pt-0 pb-1">
          {/* Progress Indicator */}
          <div className="mb-[10px]">{progressBlock}</div>

          {pageOne}

          {/* Guest Details */}
          <div className="mb-[8px]">{guestDetailsBlock}</div>

          {/* Class Selector — NEW */}
          <div className="mb-[8px]">{classSelectorBlock}</div>

          {/* Calendar */}
          <div className="mb-[8px]">{calendarBlock}</div>

          {/* Step Content (steps 1–3) */}
          {stepContent}

          {/* Pricing Summary */}
          <div className="mt-[6px] mb-[4px]">{pricingSummaryBlock}</div>
        </div>

        {/* Coupon Code */}
        <div className="flex-shrink-0 px-4 pb-2">{couponBlock}</div>
      </div>
    </div>
  );
}
